/**
 * Logger — thin wrapper around console that ALSO emits 'log:message'
 * events on the shared EventManager so views (e.g. LogView) can render
 * them. Replaces the old global log() function from gps-tracker.html.
 */
export class Logger {
    constructor(_bus) {
        this._bus = _bus;
    }
    debug(text) {
        this._emit('debug', text);
    }
    info(text) {
        this._emit('info', text);
    }
    warn(text) {
        this._emit('warn', text);
    }
    error(text) {
        this._emit('error', text);
    }
    _emit(level, text) {
        const entry = { level, text, timestamp: Date.now() };
        // Mirror to console for devtools visibility
        switch (level) {
            case 'debug':
                console.debug(text);
                break;
            case 'info':
                console.log(text);
                break;
            case 'warn':
                console.warn(text);
                break;
            case 'error':
                console.error(text);
                break;
        }
        this._bus.emit('log:message', entry);
    }
}
//# sourceMappingURL=Logger.js.map